import CloseIcon from '@/components/Icons/CloseIcon';
import CustomModal from '@/components/Modals/Modal';
import { useState } from 'react';

interface AddPromptModalProps {
  isOpen: boolean;
  onAddPrompt: (prompt: string) => void;
  onClose: () => void;
}

export default function AddPromptModal({ isOpen, onAddPrompt, onClose }: AddPromptModalProps) {
  const [prompt, setPrompt] = useState<string>('');

  const handleAddPrompt = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    onAddPrompt(prompt);
    onClose();
    setPrompt('');
  };

  return (
    <CustomModal title="Add Prompt" open={isOpen} onClose={onClose} size="3xl">
      <form onSubmit={handleAddPrompt}>
        <div>
          <p className="text-body text-neutral-400 text-center">
            Use an underscore (_) to mark any fill-in-the-blank spaces.
          </p>
          <div className="relative text-neutral-500">
            <input
              type="text"
              name="prompt"
              value={prompt}
              onChange={(e) => setPrompt(e.target.value)}
              id="prompt"
              className="input w-full mt-40 mb-40 rounded-2xs text-body border-1 border-neutral-200 px-16 py-12 text-neutral-500 placeholder:text-neutral-400 outline-none"
              placeholder="e.g “_gives me peace of mind”"
            />
            {prompt.length > 0 && (
              <CloseIcon
                className="absolute right-16 top-52 cursor-pointer"
                onClick={() => setPrompt('')}
              />
            )}
          </div>
        </div>

        <div className="flex flex-row justify-end">
          <button type="button" className="btn btn-subtle" onClick={onClose}>
            Cancel
          </button>
          <button disabled={!prompt} type="submit" className="btn btn-primary">
            Add Prompt
          </button>
        </div>
      </form>
    </CustomModal>
  );
}
